import React from "react";
import './style.scss';
import { image } from "../../../Assets";
import Count from "../../../Component/Count/Count";
import TeamSection from "../../../Component/Team/Team/Team";

const About = () =>{
    return(
        <>           
            <section className="about-main-sec">
                <div className="container">
                    <div className="row tw-justify-center">                        
                        <div className="col-lg-8 col-md-8 col-sm-12 col-12 tw-text-center">                            
                            <p>
                            As the industry grapples with a scarcity of skilled labor, Fractile Studio understands the challenges of navigating the digital landscape. We stand as experienced and accountable partners, ready to tailor our resources to meet your digital processing needs.
                            </p>
                            <h4><b>“At Fractile Studio, we are experts at recognizing and solving the problems that create friction for you.”</b></h4>
                            
                        </div>
                    </div>
                </div>
            </section>

            <section className="about-section d2">
                <div className="container">
                    <div className="md:tw-flex tw-grid tw-gap-20 tw-justify-between"> 
                        <div>
                            <div className="title">
                                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle opacity="0.1" cx="30" cy="30" r="30" fill="#157438"/>
                                <circle opacity="0.1" cx="29.9998" cy="30" r="20.1429" fill="#157438"/>
                                <circle cx="29.9999" cy="30" r="10.7143" fill="#157438"/>
                                </svg>
                                <h2>Our Mission</h2> 
                            </div>
                            <p data-aos="fade-up" data-aos-delay="200">
                            Fractile provides best-in-class BIM/VDC and Engineering Management services that focus on outcomes. Rather than focusing on just ‘what’ BIM can do, at Fractile Studio we also address the ‘why’ to create customized workflows to meet client needs and deliver expected outcomes.Our leadership has more than 50 years of experience leading construction technology departments in top construction companies. Our team will work with you to identify and achieve pragmatic solutions correctly the first time around to ensure your projects stay on schedule and under budget.
                            </p>
                        </div>
                        <div>
                            <div className="title md:tw-pt-28 tw-pt-0">
                                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle opacity="0.1" cx="30" cy="30" r="30" fill="#157438"/>
                                    <circle opacity="0.1" cx="29.9998" cy="30" r="20.1429" fill="#157438"/>
                                    <circle cx="29.9999" cy="30" r="10.7143" fill="#157438"/>
                                </svg>
                                <h2>Our Vision</h2>  
                            </div>
                            <p data-aos="fade-up" data-aos-delay="200">
                            Transforming Construction Through Innovation and Collaboration. At Fractile, we envision a construction industry where innovation and collaboration are at the forefront of every project. Our vision is to lead the way in transforming traditional construction practices by leveraging cutting-edge technology and fostering strong partnerships. We aim to redefine the construction landscape by pioneering new approaches and methodologies that enhance efficiency, sustainability, and quality. Through our dedication to innovation, we seek to empower our clients to achieve their project goals with greater speed, accuracy, and cost-effectiveness.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="about-section d2">
                <div className="container">
                    <div className="row">                        
                        <div className="col-xl-12 col-lg-12 col-md-12 col-12 d-flex align-items-center md:tw-pb-0 tw-pb-10">
                            <div>
                                <div className="title">                                    
                                    <h2 style={{color:'#157438'}}>Challenges We Solve</h2> 
                                </div>
                                <br/>
                                <p data-aos="fade-up" data-aos-delay="200" style={{fontWeight:'400',paddingBottom:'15px'}}>The US AEC industry recognizes the inefficiencies in its workflows, when it comes to 
                                    coordination and understanding of project requirements between different stakeholders. BIM/VDC services attempt to resolve 
                                    most of these issues, but fall short due to skilled technical resource shortage in the industry. Even when companies have 
                                    the resources available, the fluctuation of workload and expensive practices of training new staff due to recurring 
                                    attritions lead to project and time overruns. Fractile, in its capacity as a premier digital content creator and manager
                                     in US AEC industry, provides customized solutions specific to project needs without compromising on content and product 
                                     quality, and providing the most efficient solution to the end user.</p>
                                
                                <picture>
                                    <source media="(max-width: 600px)" srcset={image.mobileaboutimg1} />
                                    <img src={image.aboutimg1} alt="" className="tw-w-[100%]" />
                                </picture>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Count/>

            <TeamSection/>
            
        </>
    )
}

export default About;
